import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {Login} from './components/loren-login/login';
import {LorenLoginGuard} from './guards/loren-login-guard/loren-login-guard.service';
import {LOREN_ROUTER_OUTLETS} from '../../shared/constants/loren-router-outlets.constants';

const routes: Routes = [
    {
        path: '',
        outlet: LOREN_ROUTER_OUTLETS.LOGIN,
        canActivate: [
            LorenLoginGuard
        ],
        component: Login,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LorenLoginRoutingModule {
}
